/* Malichuspedia - renames the encyclopedia to "ماليكسبيديا" / "Malichuspedia" wherever the old name is still drawn
   (page text, aria-label/title attributes and the browser tab title). */
(function(){
if(window.__mzname1)return;window.__mzname1=1;
var R=[['موسوعة ماليكس','ماليكسبيديا'],['The Malichus Encyclopedia','Malichuspedia'],['the Malichus Encyclopedia','Malichuspedia'],['Malichus Encyclopedia','Malichuspedia'],['Malichus encyclopedia','Malichuspedia']];
function fx(s){for(var i=0;i<R.length;i++)if(s.indexOf(R[i][0])>=0)s=s.split(R[i][0]).join(R[i][1]);return s}
function hit(v){return v&&(v.indexOf('موسوعة ماليكس')>=0||/Malichus [Ee]ncyclopedia/.test(v))}
function run(){
 pend=0;var root=document.body;if(!root)return;
 var tw=document.createTreeWalker(root,NodeFilter.SHOW_TEXT),n,v,w;
 while((n=tw.nextNode())){v=n.nodeValue;if(hit(v)){w=fx(v);if(w!==v)n.nodeValue=w}}
 var at=root.querySelectorAll('[aria-label],[title],[alt]');
 for(var i=0;i<at.length;i++){['aria-label','title','alt'].forEach(function(a){var x=at[i].getAttribute(a);if(hit(x)){var y=fx(x);if(y!==x)at[i].setAttribute(a,y)}})}
 try{css();nav();hero()}catch(e){}
 if(hit(document.title)){var t=fx(document.title);if(t!==document.title)document.title=t}
}
var HREF='[href$="pages/malichus-encyclopedia"]';
function nm(){return /^ar/i.test(document.documentElement.lang||'')?'ماليكسبيديا':'Malichuspedia'}
function nav(){
 var N=nm(),els=document.querySelectorAll('header '+HREF+',.menu-drawer '+HREF+',.aside-menu '+HREF+',menu-drawer '+HREF+',header-drawer '+HREF);
 var uls=[],groups=[];
 for(var i=0;i<els.length;i++){var li=els[i].closest('li');if(!li||!li.parentNode||li.parentNode.tagName!=='UL')continue;
  var ul=li.parentNode,k=uls.indexOf(ul);if(k<0){uls.push(ul);groups.push([li])}else if(groups[k].indexOf(li)<0)groups[k].push(li)}
 for(var g=0;g<groups.length;g++){
  var L=groups[g],ul=uls[g],keep=null,j;
  for(j=0;j<L.length;j++)if(L[j].querySelector('details,ul,.mega-menu,.header__submenu,.submenu')){keep=L[j];break}
  if(!keep)keep=L[0];
  for(j=0;j<L.length;j++)if(L[j]!==keep){L[j].style.display='none';L[j].setAttribute('aria-hidden','true')}
  if(ul.firstElementChild!==keep)ul.insertBefore(keep,ul.firstElementChild);
  var lab=keep.querySelector(HREF);if(!lab)continue;
  var tw=document.createTreeWalker(lab,NodeFilter.SHOW_TEXT),t,first=1;
  while((t=tw.nextNode())){var tv=t.nodeValue;if(!tv.trim())continue;if(first){first=0;var nv=tv.replace(tv.trim(),N);if(nv!==tv)t.nodeValue=nv}else if(tv.trim()!==N)t.nodeValue=''}
  [lab].concat([].slice.call(lab.querySelectorAll('[title],[aria-label]'))).forEach(function(e){['title','aria-label'].forEach(function(a){var x=e.getAttribute(a);if(x!==null&&x!==''&&x!==N)e.setAttribute(a,N)})});
 }
}
function hero(){
 var NS=['ماليكسبيديا','Malichuspedia'],ks=document.querySelectorAll('.mz-kicker');
 for(var i=0;i<ks.length;i++){var k=ks[i];if(k.querySelector('.mzn-title'))continue;
  var tx=k.textContent,N=null,j;
  for(j=0;j<NS.length;j++)if(tx.indexOf(NS[j]+' · ')===0){N=NS[j];break}
  if(!N)continue;
  var rest=tx.slice(N.length+3);k.textContent='';
  var a=document.createElement('span');a.className='mzn-title';a.textContent=N;
  var b=document.createElement('span');b.className='mzn-sub';b.textContent=rest;
  k.appendChild(a);k.appendChild(b)}
}
function css(){
 if(document.getElementById('mzn-css')||!document.head)return;
 var s=document.createElement('style');s.id='mzn-css';
 s.textContent='.mz-kicker .mzn-title{display:block;font-size:clamp(44px,11vw,84px);font-weight:800;line-height:1.2;letter-spacing:0;color:#723c2b;margin:0 0 12px}.mz-kicker .mzn-sub{display:block;font-size:clamp(15px,3.6vw,20px);font-weight:600;line-height:1.7;letter-spacing:0}';
 document.head.appendChild(s)}
var pend=0;
function sched(){if(!pend){pend=1;setTimeout(run,60)}}
try{new MutationObserver(sched).observe(document.documentElement,{childList:true,subtree:true,characterData:true})}catch(e){}
run();
})();
